export default "__VITE_ASSET__BOO3LM9$__"